/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EbankingServiceRoleProperties
 */
export interface EbankingServiceRoleProperties {
    /**
     * 
     * @type {string}
     * @memberof EbankingServiceRoleProperties
     */
    propertiesType: string;
    /**
     * eBanking J-number
     * @type {string}
     * @memberof EbankingServiceRoleProperties
     */
    jNumber?: string;
    /**
     * Blocked status
     * @type {boolean}
     * @memberof EbankingServiceRoleProperties
     */
    isBlocked?: boolean;
    /**
     * Last login date
     * @type {Date}
     * @memberof EbankingServiceRoleProperties
     */
    lastLogin?: Date;
}

/**
 * Check if a given object implements the EbankingServiceRoleProperties interface.
 */
export function instanceOfEbankingServiceRoleProperties(value: object): value is EbankingServiceRoleProperties {
    if (!('propertiesType' in value) || value['propertiesType'] === undefined) return false;
    return true;
}

export function EbankingServiceRolePropertiesFromJSON(json: any): EbankingServiceRoleProperties {
    return EbankingServiceRolePropertiesFromJSONTyped(json, false);
}

export function EbankingServiceRolePropertiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): EbankingServiceRoleProperties {
    if (json == null) {
        return json;
    }
    return {
        
        'propertiesType': json['propertiesType'],
        'jNumber': json['jNumber'] == null ? undefined : json['jNumber'],
        'isBlocked': json['isBlocked'] == null ? undefined : json['isBlocked'],
        'lastLogin': json['lastLogin'] == null ? undefined : (new Date(json['lastLogin'])),
    };
}

export function EbankingServiceRolePropertiesToJSON(json: any): EbankingServiceRoleProperties {
    return EbankingServiceRolePropertiesToJSONTyped(json, false);
}

export function EbankingServiceRolePropertiesToJSONTyped(value?: EbankingServiceRoleProperties | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'propertiesType': value['propertiesType'],
        'jNumber': value['jNumber'],
        'isBlocked': value['isBlocked'],
        'lastLogin': value['lastLogin'] == null ? value['lastLogin'] : value['lastLogin'].toISOString(),
    };
}

